import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { routes } from ".";
import { getUserIsLogin } from "../lib/utils/userAsyncStorage";

const Authorized = () => {
  const isLogin = getUserIsLogin();
  const location = useLocation();

  return isLogin ? (
    <Outlet />
  ) : (
    <Navigate to={routes.signin} state={{ from: location }} replace />
  );
};

export default Authorized;
